export const declaredCategoryLabel = (category, fallback) => category?.trim() || fallback;

export const publicRegistrationRequiredReady = (form) => Boolean(
    form.player.first_name.trim() && form.player.last_name.trim() && form.player.birth_date &&
    form.player.gender && form.guardian.first_name.trim() && form.guardian.last_name.trim() &&
    form.guardian.phone.trim() && form.guardian.email.trim() && form.consents.declarant_name.trim() &&
    form.consents.engagement_accepted && form.consents.parental_authorization_accepted
);
